import { Box } from '@mui/material'
import React from 'react'

import { AzureAuthenticationSectionReadOnly } from 'components/common/mapped-entities/azure/authentication/AzureAuthenticationSectionReadOnly'
import { AzureNewAuthenticationContainer } from 'components/common/mapped-entities/azure/authentication/AzureNewAuthenticationContainer'
import { GcpAuthenticationSectionReadOnly } from 'components/common/mapped-entities/gcp/authentication/GcpAuthenticationSectionReadOnly'
import { GcpNewAuthenticationContainer } from 'components/common/mapped-entities/gcp/authentication/GcpNewAuthenticationContainer'
import { AWSAuthenticationForm } from 'components/getting-started/aws/AWSAuthenticationForm'
import { EditAuthenticationForm } from 'components/status-checks/edit/EditAuthenticationForm'
import {
  ObservabilityToolType,
  type TeamExternalIntegration
} from 'types/api/status-checks/status-check'

export function ThirdPartyAuth({
  externalIntegrations,
  onClose,
  selectedIntegration,
  type
}: {
  externalIntegrations: TeamExternalIntegration[]
  selectedIntegration?: TeamExternalIntegration | undefined
  type: ObservabilityToolType
  onClose: () => void
}) {
  switch (type) {
    case ObservabilityToolType.AWS:
      return selectedIntegration ? (
        <EditAuthenticationForm
          externalIntegration={selectedIntegration}
          externalIntegrations={externalIntegrations}
          handleCancel={onClose}
        />
      ) : (
        <AWSAuthenticationForm
          externalIntegrations={externalIntegrations}
          hasIntroText={false}
          onSuccess={onClose}
        />
      )

    case ObservabilityToolType.AZURE:
      return (
        <Box sx={{ marginTop: 2 }}>
          {selectedIntegration ? (
            <AzureAuthenticationSectionReadOnly
              selectedIntegration={selectedIntegration}
            />
          ) : (
            <AzureNewAuthenticationContainer isEnabled onSuccess={onClose} />
          )}
        </Box>
      )

    case ObservabilityToolType.GCP:
      return (
        <Box sx={{ marginTop: 2 }}>
          {selectedIntegration ? (
            <GcpAuthenticationSectionReadOnly
              selectedIntegration={selectedIntegration}
            />
          ) : (
            <GcpNewAuthenticationContainer isEnabled onSuccess={onClose} />
          )}
        </Box>
      )

    default:
      return null
  }
}
